import { Injectable } from '@angular/core';
import { of, from } from 'rxjs';
import { mergeMap, mergeAll, toArray, shareReplay } from 'rxjs/operators';

import { EnumsService } from '@library/core/services';
import { ShipmentModes, TrafficDirections, ShippingTypes } from '@library/common/models';

@Injectable({
   providedIn: 'root'
})
export class ReportEnumsService {

   constructor(
       public enums: EnumsService,
   ) { }

   public serviceLevel() {
       return this.enums.servicelevels();
   }

   public incoterms() {
      return from( ShipmentModes ).pipe(
         mergeMap( m => this.enums.incoterms( m )),
         mergeAll(), toArray(), shareReplay(),
      );
   }

   public trafficDirection() {
      return of([ ...TrafficDirections ] as string[] );
   }

   public shippingType() {
      return of([ ...ShippingTypes ]);
   }

   public containerType() {
      return this.enums.containerTypes();
   }

   public movementType() {
      return of([ 'door_to_door', 'door_to_port', 'port_to_door', 'port_to_port' ]);
   }

   public module() {
      return of([ 'domestic', 'international', 'ocean' ]);
   }
}
